import React, { FC, useEffect } from 'react';

import { Container, Typography } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import cn from 'classnames';
import { Trans, useTranslation } from 'react-i18next';

import { useTextStyles } from '../../utils/styles';
import useStyles from './styles';

const IncognitoWarning: FC = () => {
  const textClasses = useTextStyles();
  const classes = useStyles();

  const { t } = useTranslation();

  useEffect(() => {
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles?.parentNode?.removeChild(jssStyles);
    }
  }, []);

  return (
    <>
      <CssBaseline />
      <div className={classes.wrapper}>
        <Container>
          <Typography variant="h1" className={cn(classes.title, textClasses.h1)} align="center">
            {t('error.cookiesErrorTitle')}
          </Typography>
          <Typography className={cn(classes.description, textClasses.bodyIntro)} align="center">
            <Trans i18nKey="error.cookiesErrorDesc">
              Your browser has blocked access to third-party cookies which are required to view this
              course; this may be because you are using "incognito" mode. Please either re-open this
              page in not in "incognito" mode or enable third-party cookie access for this site. You
              can follow these&#x20
              <a
                target="_blank"
                rel="noreferrer"
                href="https://support.microsoft.com/en-us/office/enable-cookies-6b018d22-1d24-43d9-8543-3d35ddb2cb52"
              >
                instructions
              </a>{' '}
              to allow third-party cookies
            </Trans>
          </Typography>
        </Container>
      </div>
    </>
  );
};

export default IncognitoWarning;
